import Vue from 'vue'
import VueI18n, { LocaleMessageObject } from 'vue-i18n'
import yaml from 'js-yaml'

Vue.use(VueI18n)

const getInitialLocale = () => {
  const storedLocale = window.localStorage.getItem('locale')
  return storedLocale || 'en'
}

export const i18n = new VueI18n({
  locale: getInitialLocale()
})

/** 
 * Product messages are stored in public folder and are loaded in via
 * loadPublicMessages right before initializing Vue in @/main.ts
 */
export function loadPublicMessages (locales: string[]): Promise<void[]> {
  const fetchPromises = locales.map((locale) => {
    return fetch(`./i18n/${locale}.yml`)
      .then((response) => response.text())
      .then((response) => {
        const productMessages = yaml.safeLoad(response)
        if (typeof productMessages === 'object') {
          i18n.setLocaleMessage(locale, { global: productMessages } as LocaleMessageObject)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  })

  return Promise.all(fetchPromises)
}
